import 'bootstrap/dist/css/bootstrap.min.css';
import './App.scss';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import AnnouncementBar  from './components/AnnouncementBar/AnnouncementBar';
import Header           from './components/Header/Header';
import HeroSlider       from './components/HeroSlider/HeroSlider';
import GreenSection     from './components/GreenSection/GreenSection';
import StorySection     from './components/StorySection/StorySection';
import EventsSection    from './components/EventsSection/EventsSection';
import ThroughYourEyes  from './components/ThroughYourEyes/ThroughYourEyes';
import Footer           from './components/Footer/Footer';
import ExperiencePage   from './pages/ExperiencePage/ExperiencePage';
import WorkPage         from './pages/WorkPage/WorkPage';
import StudyPage        from './pages/StudyPage/StudyPage';
import InvestPage       from './pages/InvestPage/InvestPage';
import ServicesPage     from './pages/ServicesPage/ServicesPage';
import EventsPage       from './pages/EventsPage/EventsPage';
import { useLanguage }  from './context/LanguageContext';

const pageKeyMap = {
  '/':           'home',
  '/experience': 'experience',
  '/work':       'work',
  '/study':      'study',
  '/invest':     'invest',
  '/services':   'services',
  '/events':     'events',
};

function App() {
  const { t } = useTranslation();
  const { lang } = useLanguage();
  const path = window.location.pathname;

  useEffect(() => {
    const key = pageKeyMap[path] || 'home';
    document.title = t(`pageMeta.${key}.title`);
    const metaDesc = document.querySelector('meta[name="description"]');
    if (metaDesc) metaDesc.setAttribute('content', t(`pageMeta.${key}.description`));
  }, [lang, t, path]);

  return (
    <div className="app">
      <AnnouncementBar />
      <Header />
      <main className="main">
        {path === '/experience' ? (
          <ExperiencePage />
        ) : path === '/work' ? (
          <WorkPage />
        ) : path === '/study' ? (
          <StudyPage />
        ) : path === '/invest' ? (
          <InvestPage />
        ) : path === '/services' ? (
          <ServicesPage />
        ) : path === '/events' ? (
          <EventsPage />
        ) : (
          <>
            <HeroSlider />
            <GreenSection />
            <StorySection />
            <EventsSection />
            <ThroughYourEyes />
          </>
        )}
      </main>
      <Footer />
    </div>
  );
}

export default App;
